module.exports = __webpack_public_path__ + "img/bobienski.c436f8b6.jpg";